<template>
  <div class="row align-content-center justify-content-center my-5">
    <div class="col-md-6 my-5">
      <div class="row">
        <div class="col-md-4">
          <button
            class="btn btn-outline-primary btn-block mb-2"
            @click="$router.push({ name: 'Home' })"
          >
            {{$t('global-save-exit-text')}}
          </button>
        </div>
        <div class="col-md">
          <button
            class="btn btn-primary  btn-block"
            @click="$emit('update-continue-screen', false, true)"
          >
            {{$t('global-continue-to-submit-app-btn')}}
          </button>
        </div>
      </div>

      <div class="mt-2">
        <span class="mt-2" v-html="$t('global-continue-to-submit-app-message')"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
